import { Close, Pencil } from "src/components/svg";
import { _ } from "src/services";
import phPackage from "src/assets/static/img/main/icons/ph_package.png";

export const FavoriteShimmer: React.FC = () => {

    return (
        <>
            {
                [...new Array(4)].map((x, i) => (
                    <div className="favorite-row" key={i}>
                        <div className="favorite-header px-2 px-md-0 d-flex justify-content-between align-items-center">
                            <div className="profile-sub-title shimmer"></div>
                            <button disabled className={`btn btn-edit-favorite`}><Pencil />{_("edit")}</button>
                        </div>
                        <div className="d-flex py-2">
                            {[...new Array(3)].map((y, j) => (
                                <div className="d-flex sport-item" key={j}>
                                    <img alt=""
                                        width={32} height={32}
                                        src={phPackage}
                                        className={`logo lazy${i === 0 ? "" : " large"}`} />
                                    <div className="d-flex flex-column">
                                        {i > 0 && <span className="shimmer"></span>}
                                        <span className="shimmer"></span>
                                    </div>
                                    <button disabled><Close /></button>
                                </div>
                            ))}
                        </div>
                    </div>
                ))
            }
        </>
    );

};